<template>
  <div class="no_data_cla">
    <img style="width:400px" src="@/assets/new/search_no_data.png" />
    <span class="no_data_tips">抱歉，没有找到任何内容</span>
  </div>
</template>

<script>
export default {
  name: 'zkNoData',
  data() {
    return {}
  },
  methods: {},
  mounted() {}
}
</script>

<style scoped lang="less">
.no_data_cla {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .no_data_tips {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    letter-spacing: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/isNoData.vue